const initialState = {
    image: [], 
    data:[],
    
  
  };
  
  const SupViewAssReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_IMG_SUCCESS':
            return {... state, image:action.payload};
            case 'FETCH_DATA_SUCCESS':
            return {... state, data:action.payload};
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default SupViewAssReducers;
  
  